// *********************************************************
//
//  型関連
//
// *********************************************************

/**
 * 数値を指定桁数まで0埋め
 *
 * @param val 数値
 * @param size 桁数
 * @return 0埋めされた数値
 */
export const padZero = (val: string | number | null | undefined, size: number): string | null | undefined => {
  if (typeof val === 'undefined') {
    return undefined;
  }

  if (val === null) {
    return null;
  }

  let s = val + '';
  while (s.length < size) {
    s = '0' + s;
  }
  return s;
};


/**
 * 小数桁数を指定して丸め
 *
 * @param val 数値
 * @param n 残したい小数点以下の桁数
 * @return 丸め後数値
 */
export const floatFormat = (val: number , n: number ): number => {/*numberjs*/
  const pow = Math.pow( 10 , n ); // 10のn乗
  return Math.round( val * pow ) / pow;
};


/**
 * 変数が空かどうかチェック
 *
 * @param val 任意の値
 * @return undefined, null, 全角スペース、半角スペース、タブのみの場合true、それ以外ならfalse
 */
export const isBlank = (val: any): boolean => {
  if (typeof val === 'undefined') {
    return true;
  }
  if (val === null) {
    return true;
  }

  if (typeof val !== 'string') {
    return false;
  }

  if (val.match(/^[\s　]*$/)) {
    return true;
  }
  return false;
};


/**
 * 変数が数値かどうかチェック
 *
 * @param val チェック対象
 * @return 以下の順に判定
 * (1) null もしくは undefined の場合、false
 * (2) number 型の場合、true
 * (3) string 型の場合、数値を表す文字列の場合 true
 * (4) 上記以外の場合、false
 */
export const isNumber = (val: any): boolean => {
  if (val == null) {
    return false;
  } else if (typeof val === 'number') {
    return true;
  } else if (typeof val === 'string' && isBlank(val) === false) {
    return !isNaN(Number(val));
  } else {
    return false;
  }
};

/**
 * 変数がオブジェクトかどうかチェック
 * https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
 *
 * @param o チェック対象
 * @return o がオブジェクトの場合 true、そうでなければ false
 */
export const isObject = (o: any): boolean => o !== null && typeof o === 'object' && Array.isArray(o) === false;

/**
 * ユーザがナベルアカウントかどうかチェック
 *
 * @param mailAddress メールアドレス
 * @return mailAddress が @mail.nabel.co.jp もしくは example@example.com の場合 true, そうでなければfalse
 */
export const isNabelUser = (mailAddress: string | undefined | null): boolean => {
  if (typeof mailAddress === 'undefined') {
    return false;
  }
  if (mailAddress === null) {
    return false;
  }
  if (mailAddress.match(/@mail.nabel.co.jp*$/)) {
    return true;
  }
  if (mailAddress === 'example@example.com') {
    return true;
  }
  return false;
};

/**
 * 文字列を Uint8Array に変換
 * https://stackoverflow.com/questions/6965107/converting-between-strings-and-arraybuffers
 *
 * @param str 文字列
 * @return Uint8Array変換後
 */
export const uint8AbFromStr = (str: string): Uint8Array => {
  const strUtf8 = unescape(encodeURIComponent(str));
  const ab = new Uint8Array(strUtf8.length);
  for (let i = 0; i < strUtf8.length; i++) {
    ab[i] = strUtf8.charCodeAt(i);
  }
  return ab;
};
